import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export const PencilIcon = ({ className, color = Color.White }: NewIconProps) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.21736 21.2685C3.76373 21.3707 3.37713 21.2596 3.05756 20.9353C2.73799 20.611 2.62929 20.2268 2.73146 19.7826L3.68799 15.2467L8.75324 20.312L4.21736 21.2685ZM9.96846 19.3772L4.62279 14.0315L15.5565 3.09781C15.9434 2.71085 16.4088 2.51736 16.9527 2.51736C17.4965 2.51736 17.9572 2.71085 18.3348 3.09781L20.9021 5.66519C21.2891 6.04272 21.4826 6.50341 21.4826 7.04726C21.4826 7.59111 21.2891 8.05652 20.9021 8.44349L9.96846 19.3772Z"
      fill={color}
    />
  </svg>
);
